import React from "react"

import BackgroundImage from "../../../common/BackgroundImage"
import ShortTextWithReadMore from "../../../common/ShortTextWithReadMore"
import ContentLoaderLines from "../../../common/content-loading/ContentLoaderLines"

const KeyIssueViewItemDetails = ({
    name,
    subtitle,
    description,
    status,
    imageUrl,
    isFetching
}) => (
    <div className="widget">
        <div className="widget-content">
            <h3 className="first-heading">
                <span className="icon icon-headline" />Name
            </h3>
            <ContentLoaderLines
                isFetching={isFetching}
                minLineLength={25}
                maxLineLength={70}
            >
                <p>{name || "No name"}</p>
            </ContentLoaderLines>
            <h3>
                <span className="icon icon-status" />Status
            </h3>
            <ContentLoaderLines isFetching={isFetching} lineLength={30}>
                <p>{status || "No status"}</p>
            </ContentLoaderLines>
            <h3>
                <span className="icon icon-description" />Subtitle
            </h3>
            <ContentLoaderLines isFetching={isFetching}>
                <p>{subtitle || "No subtitle"}</p>
            </ContentLoaderLines>
            <h3>
                <span className="icon icon-description" />Description
            </h3>
            <ContentLoaderLines isFetching={isFetching} lines={5}>
                <ShortTextWithReadMore
                    text={description}
                    placeholder="No description"
                />
            </ContentLoaderLines>
            <h3>
                <span className="icon icon-heroimg" />Hero image
            </h3>
            <BackgroundImage
                classList={["item-background-image"]}
                imageUrl={imageUrl}
            />
        </div>
    </div>
)

export default KeyIssueViewItemDetails
